<template>
  <div>
    <loading-spinner v-if="loading" />
    <template v-else>
      <b-table-simple>
        <b-tr v-for="template in templateTypes" :key="template.id">
          <b-td>
            <h3>{{ template.id }}. {{ template.name }}</h3>
            <div>
              <span v-label-key="'TEMPLATE_TYPES_ENABLED_CHAINS'"
                >Chains Enabled</span
              >
              <b-badge pill variant="success"
                ><span v-if="template.chainEnabledList">{{
                  template.chainEnabledList.length
                }}</span
                ><span v-else>0</span></b-badge
              >
            </div>
            <div>
              <span v-label-key="'TEMPLATE_TYPES_DISABLED_CHAINS'"
                >Chains Disabled</span
              >

              <b-badge pill variant="danger" v-if="template.chain_disabled">{{
                template.chain_disabled.length
              }}</b-badge>
            </div>
          </b-td>
          <b-td class="text-right">
            <app-chain-selector
              :chain-ids="chainEnabledIds(template)"
              @select="saveChainTypes(template, $event)"
            >
              <b-button variant="primary">
                <span v-label-key="'CHAIN_SELECTOR_SELECT_CHAINS'"
                  >Select Chains</span
                >
              </b-button>
            </app-chain-selector>
          </b-td>
        </b-tr>
      </b-table-simple>
    </template>
  </div>
</template>

<script>
import $api from '@/services/api';

import LoadingSpinner from '@/components/LoadingSpinner';
import AppChainSelector from '@/components/ChainSelector';

import { mapState } from 'vuex';

export default {
  name: 'TemplateTypesTab',
  components: {
    LoadingSpinner,
    AppChainSelector,
  },
  computed: {
    ...mapState('global', {
      chains: 'chains',
    }),
    level() {
      if (this.$route.path.includes('subdi')) return 'subdistributor';
      return 'distributor';
    },
    chainEnabledIds() {
      return (templateType) => {
        if (!templateType.chainEnabledList) return [];
        return templateType.chainEnabledList.map((chain) => chain.id);
      };
    },
  },
  data() {
    return {
      templateTypes: null,
      loading: false,
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loading = true;
      try {
        const templatetypes = await $api.get(
          `/v1/dashboard/templatetypes/${this.level}s/${this.$route.params.id}`,
        );
        this.templateTypes = templatetypes;
        this.processData();
        this.loading = false;
      } catch (e) {
        alert(`Error retrieving template types: ${JSON.stringify(e)}`);
      }
    },
    processData() {
      if (!this.chains || !this.templateTypes) return;

      this.templateTypes.forEach((templateType) => {
        templateType.chainEnabledList = this.chains.filter((chain) => {
          return !templateType.chain_disabled.some(
            (disabledChain) => disabledChain.id === chain.id,
          );
        });
      });
    },
    async saveChainTypes(tt, $event) {
      this.loading = true;
      try {
        const templateType = JSON.parse(JSON.stringify(tt));
        delete templateType.chainEnabledList;
        // Filter out the unselected chains
        const chainIds = this.chains
          .filter((chain) => $event.indexOf(chain.id) === -1)
          .map((chain) => chain.id);
        await $api.put(
          `/v1/dashboard/disabledtemplatetypes/${this.level}s/${this.$route.params.id}`,
          {
            chainIds,
            templateTypeId: templateType.id,
          },
        );
      } catch (e) {
        console.error(e);
        alert(JSON.stringify(e));
      }
      this.loadData();
    },
  },
  watch: {
    chains() {
      this.processData();
    },
  },
};
</script>
<style scoped>
.template-types-tab__label {
  margin-right: 10px;
}
</style>
